module.exports = __webpack_public_path__ + "img/preview-17.59807f81.jpg";